module.exports = __webpack_public_path__ + "static/media/Calendar.9c961993.svg";